export default __webpack_public_path__ + "static/media/green_loc_mark.539a10ee.svg";